import prod from './prod.json'
import stage from './stage.json'

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT as 'stage' | 'prod' | undefined

const config = { prod, stage } as const

const tableColumnKeysConf = environment ? config[environment] : stage

export default tableColumnKeysConf
